import {AttachmentDetails, Props} from './ViewAttachedFiles.model';
import {Button} from 'antd';
import {FormattedMessage} from 'react-intl';
import styles from './ViewAttachedFiles.module.scss';
import Popup from '../Popup/Popup';
import {useEffect, useState} from 'react';
import Icon from '../Icon/Icon';

const ViewAttachedFiles = (props: Props) => {
	const {attachments, onClose} = props;
	const [attachmentsDetails, setAttachmentsDetails] =
		useState<Array<AttachmentDetails>>();

	const getTypeByExtension = (type: string): string => {
		if (type === '.pdf' || type === 'docx') return 'text';
		if (
			type === '.mp4' ||
			type === '.mkv' ||
			type === '.mov' ||
			type === '.3gp' ||
			type === '.webm'
		)
			return 'video';
		if (
			type === '.mp3' ||
			type === '.aac' ||
			type === '.wav' ||
			type === '.flac' ||
			type === '.ogg' ||
			type === '.wma' ||
			type === '.aiff'
		)
			return 'audio';
		if (type === '.png' || type === '.jpg' || type === '.jpeg' || type === ".gif") return 'photo';
		return '';
	};

	const getIconByType = (type: string) => {
		if (type === 'text')
			return (
				<Icon
					name="file-pdf"
					width="20px"
					height="20px"
					color="gray"
					type="solid"
				/>
			);
		if (type === 'audio')
			return (
				<Icon
					name="microphone"
					width="20px"
					height="20px"
					color="gray"
					type="solid"
				/>
			);
		if(type === 'video')
			return (
				<Icon name="video" width="20px" height="20px" color="gray" type="solid" />
			);
		return <Icon name="image" width="20px" height="20px" color="gray" />
	};

	const getDetailsAboutAttachments = () => {
		let details: Array<AttachmentDetails> = [];
		attachments.forEach((el: string) => {
			const firstSplit = el.split('/');
			const name = firstSplit[firstSplit.length - 1].split('?')[0].substring(36,);
			const extension = '.' + name.split('.')[1];
			const type = getTypeByExtension(extension);
			details.push({extension, name, type, url: el});
		});
		setAttachmentsDetails(details);
	};

	useEffect(() => {
		getDetailsAboutAttachments();
	}, [attachments]);
	
	const downloadAll = () => {
		attachments.forEach((url) => {
			window.open(url);
		})
	};

	return (
		<Popup
			size="small"
			title={{target: 'itemsInThisAttachment'}}
			onClose={onClose}
		>
			<>
				<div className={styles.wrapper}>
					<span className={styles.attachmentLength}>
						{attachments.length} <FormattedMessage id="feedback.files"/>
					</span>
					<Button type="primary" style={{alignSelf: "center"}} onClick={downloadAll}>
						<FormattedMessage id="buttons.downloadAll"/>
					</Button>
				</div>

				{attachmentsDetails?.map((attachment) => {
					return (
						<div className={styles.attachments}>
							<div className={styles.leftSide}>
								<div className={styles.icon}>
									{getIconByType(attachment.type)}
								</div>
								<div className={styles.attachmentName}>
									<span>{attachment.name}</span>
								</div>
							</div>
							<div className={styles.rightSide}>
								<a download target="_blank" href={attachment.url}>
								<Icon
									name="download"
									width="20px"
									height="20px"
									color="gray"
									type="solid"
								/>
								</a>
							</div>
						</div>
					);
				})}
			</>
		</Popup>
	);
};
export default ViewAttachedFiles;
